import React from 'react';
import ReactDOM from 'react-dom';
import App from './lesson18/App';



ReactDOM.render(<App/>, document.getElementById('root'));
